<template>
  <div class="resource-detail maxW" style="margin-top: 8%;">
    <div class="resource-nav-link">
      <router-link to="/home/resourceList">{{
        $t("homepage.resource")
      }}</router-link>
      <strong>
        <i>></i>
        {{ resourceData.name }}.{{ resourceData.postfix }}
      </strong>
    </div>
    <div class="resource-content clear">
      <div class="resource-content-c">
        <div class="resource-content-top clear">
          <img
            :src="
              hostURL +
              '/static/index/images/format/resourceicon' +
              resourceData.file_type +
              '.png'
            "
            class="resource-icon"
          />
          <div class="resource-con-info">
            <div class="resource-box-l fl">
              <h2 class="resource-title">
                {{ resourceData.name }}.{{ resourceData.postfix }}
              </h2>
              <div class="create-info">
                <span class="creater-name">{{ resourceData.u_name }}</span>
                <em>
                  {{ $t("global.uploadTime") }}:
                  <i v-if="resourceData.create_time" class="create-time">{{
                    resourceData.create_time.slice(0, 10)
                  }}</i>
                </em>
                <em>
                  {{ $t("global.size") }}：
                  <i class="file-size">{{ filesize }}</i>
                </em>
                <em>
                  {{ $t("global.score") }}：
                  <strong>
                    <i class="score">{{ resourceData.scores }}</i>
                  </strong>
                </em>
                <ul class="resource-content-mid clear">
                  <li>
                    <i class="ipng icon_see"></i>
                    <em class="clicks"
                      >{{
                        resourceData.clicks == 0 ? "1" : resourceData.clicks
                      }}
                      {{ $t("global.check") }}</em
                    >
                  </li>
                  <li>
                    <i class="ipng download01"></i>
                    <em class="downloads"
                      >{{ resourceData.downloads }}
                      {{ $t("global.download") }}</em
                    >
                  </li>
                </ul>
              </div>
            </div>
            <el-button
              type="primary"
              class="download-btn fr"
              @click="downloadFile()"
              >{{ $t("global.download") }}
            </el-button>
          </div>
        </div>
        <div class="resource-content-bottom">
          <template v-if="viewData.file_type == 3">
            <div class="imgBox">
              <img
                :src="hostURL + viewData.src"
                @click="imgPreview(hostURL + viewData.src)"
              />
            </div>
          </template>
          <template v-else-if="viewData.file_type == 1">
            <iframe
              :src="hostURL + viewData.url"
              style="width: 100%; height: 500px"
            ></iframe>
          </template>
          <template v-else-if="viewData.file_type == 2">
            <div class="common-box">viewData.content</div>
          </template>
          <template v-else-if="viewData.file_type == 5">
            <div class="common-box">
              <audio
                id="voicepoauy"
                controls="controls"
                :src="mp3url"
                controlsList="nodownload"
                autoplay
              >
                Your browser does not support the audio tag.
              </audio>
            </div>
          </template>
          <template v-else-if="viewData.file_type == 6" style="height:100%">
            <!-- <nativeVideo v-if="viewData.transform_status == 1" :playParam.sync="playParam"></nativeVideo> -->
            <dplayerA
              v-if="viewData.transform_status == 1 && videoFlag"
              :playParam.sync="playParam"
            ></dplayerA>
            <div v-else class="transform-loading">
              {{ $t("homepage.transcoding") }}
            </div>
          </template>
          <div class="empty-bgc-img" v-if="pleaceholder == true">
            <div class="resource-mask">
              <span>{{ tipWords }}</span>
            </div>
          </div>
        </div>
        <div class="resource-content-tool clear">
          <div class="mark fl">
            <span>{{ $t("global.score") }}</span>
            <el-rate
              v-if="isMark == false"
              :allow-half="true"
              :max="5"
              v-model="score"
              @change="addMark"
            ></el-rate>
            <el-rate
              v-else
              :value="score / 2"
              :allow-half="true"
              :max="5"
              disabled
            ></el-rate>
          </div>
        </div>
      </div>
    </div>

    <image-viewer
      v-if="imagePreview.showViewer"
      :initial-index="imageIndex"
      :on-close="closeViewer"
      :url-list="imagePreview.previewSrcList"
    >
    </image-viewer>
  </div>
</template>
<script>
// import nativeVideo from '@/components/common/nativeVideo'
import dplayerA from "@/components/common/dplayerA";
import { fail } from "assert";
export default {
  components: {
    // nativeVideo
    dplayerA,
  },
  data() {
    return {
      player: null, // 播放器
      hostURL: "",
      userId:
        sessionStorage.getItem("user_info_str") &&
        JSON.parse(sessionStorage.getItem("user_info_str")).id,
      resourceId: this.$route.query.id,
      resourceData: {}, // 资源数据
      filesize: "", //文件大小(带单位)
      score: 0, // 评分
      isMark: false, //是否已经评分
      isCollect: false, //是否已经收藏
      allowLoad: 1, //1允许下载，0不允许
      sectionId: null, //同类学段id
      gradeId: null, //同类年级id
      similarResourceData: [], //同类资源数组
      pleaceholder: false, //资源预览没数据的占位符
      tipWords: "", //资源预览提示语
      viewData: {}, //预览的数据
      playParam: {
        //视频预览
        play_url: "",
      },
      mp3url: "", //音频
      clicksCount: 0,
      showShare: false, //显示分享弹窗
      shareLink: "", // 分享地址
      isShoreUrl: "",
      isShareLink: null,
      changeCopy: 1, // 选择复制
      videoSign: "",
      imagePreview: {
        showViewer: false,
        previewSrcList: [],
      },
      imgViewUrl: "",
    };
  },
  created() {
    this.hostURL = sessionStorage.getItem("host_addr");
    this.getResource();
    this.getViewURL();
  },
  beforeDestroy() {
    this.changeClick();
  },
  mounted() {},
  computed: {
    imageIndex() {
      return this.imagePreview.previewSrcList.indexOf(this.imgViewUrl);
    },
  },
  methods: {
    imgPreview(url) {
      this.imgViewUrl = url;
      this.imagePreview.showViewer = true;
      this.imagePreview.previewSrcList = [url];
    },
    closeViewer() {
      this.imagePreview.showViewer = false;
    },
    // 根据资源id获取资源
    getResource() {
      let success = (res) => {
        sessionStorage.setItem(
          "sharePath",
          this.BASE_URL + "/home/resourceDetail?id=" + res.data[0].id
        );
        this.videoSign = res.data[0].resource_sign;
        this.isShoreUrl = res.data[0].path;
        this.isShareLink = res.data[0].is_share;
        if (res.data.length != 0) {
          this.resourceData = res.data[0];
          // 转换一下文件大小：
          let size = res.data[0].filesize / 1024 / 1024;
          if (Math.floor(size) != 0) {
            this.filesize = Math.floor(size) + "mb";
          } else {
            this.filesize = Math.floor(size * 1024) + "kb";
          }
          // 判断当前这个资源是否已经收藏
          res.data[0].f_id == null
            ? (this.isCollect = false)
            : (this.isCollect = true);
          // 判断是否已对资源进行评分
          if (res.data[0].f_co_score == null) {
            this.isMark = false;
          } else {
            this.score = res.data[0].f_co_score;
            this.isMark = true;
          }
          //是否允许下载
          this.allowLoad = res.data[0].is_download;

          // 获取学段、年级的id
          this.sectionId = res.data[0].study_section_id;
          this.gradeId = res.data[0].grade_id;
          this.clicksCount = res.data[0].clicks;
        } else {
          this.$message.warning(this.$t("homepage.deleted"));
          this.$router.push("/home/resourceList");
        }
      };

      this.$ajax({
        url: "api/resource/resource",
        method: "get",
        params: {
          resource_sign: sessionStorage.getItem("resource_sign"),
          userid: this.userId,
        },
        func: {
          success: success,
        },
      });
    },
    // 修改点击次数
    changeClick() {
      let clicks = this.clicksCount;
      if (clicks == 0) {
        clicks++;
      }
      let success = (data) => {};
      this.$ajax({
        url: "api/resource/resource",
        method: "put",
        data: {
          id: this.resourceId,
          // resource_sign: sessionStorage.getItem('resource_sign'),
          clicks: clicks + 1,
        },
        func: {
          success: success,
        },
      });
    },
    // 添加评分
    addMark() {
      //如果已评分了，就不能再评
      if (this.isMark == true) {
        return false;
      }
      if (!this.userId) {
        this.$message.warning(this.$t("homepage.needLogin"));
        this.score = 0;
        return false;
      }

      let success = (data) => {
        this.$message.success(this.$t("global.successfullyScored"));
        this.getResource();
      };
      this.$ajax({
        url: "api/comment/comment",
        method: "post",
        data: {
          res_id: this.resourceId,
          user_id: this.userId,
          origin: 1,
          score: this.score * 2,
        },
        func: {
          success: success,
        },
      });
    },
    // 下载：
    downloadFile() {
      if (localStorage.getItem("token")) {
        window.location.href =
          this.hostURL +
          "/index/resource/resourcedownload?id=" +
          this.resourceId;
      } else {
        this.$message.warning(this.$t("homepage.needLogin"));
      }
    },
    // 获取同类资源
    getSimilarResource(sectionId, gradeId) {
      var array = {};
      array[0] = "id";
      array[1] = "create_time";
      array[2] = "clicks";
      array[3] = "downloads";
      var orderby = array[parseInt(4 * Math.random())];
      let success = (data) => {
        this.similarResourceData = data.data.rows;
      };
      this.$ajax({
        url: "api/resource/resource",
        method: "get",
        params: {
          data_type: 1,
          grade_id: gradeId,
          orderby: orderby,
          page: 1,
          size: 6,
          study_section_id: sectionId,
          not_in_file_type: 2,
          status: 1,
          authonity: 1,
        },
        func: {
          success: success,
        },
      });
    },
    // 换一批
    changeList() {
      this.getSimilarResource(this.sectionId, this.gradeId);
    },
    //获取资源预览的地址
    getViewURL() {
      let success = (res) => {
        if (is_empty(res.data)) {
          this.pleaceholder = true;
          this.tipWords = this.$t("homepage.onlyDown");
        } else {
          if (res.data.code == 404) {
            this.pleaceholder = true;
            this.tipWords = this.$t("homepage.transcoding");
          } else {
            this.viewData = res.data;
            if (res.data.file_type == 6) {
              //视频rtmp流
              this.playParam.play_url = res.data.mp4url;
              this.videoFlag = true;
            }
            if (res.data.file_type == 5) {
              //音频
              this.mp3url = this.hostURL + res.data.mp3url;
            }
          }
        }
      };
      this.$ajax({
        url: "api/resource/resource_view",
        method: "get",
        params: {
          // id: this.resourceId
          resource_sign: sessionStorage.getItem("resource_sign"),
        },
        func: {
          success: success,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.share_text {
  font-size: 16px;

  .el-radio-group {
    margin: 20px 0 15px 0;
  }

  .el-radio__label {
    font-size: 15px;
  }
}

.tcp-skin .vjs-big-play-button .vjs-button-icon {
  display: none !important;
}

.video-js .vjs-big-play-button {
  display: none !important;
}

.video-js,
.vjs-custom-skin > .video-js {
  width: 100%;
  height: 100%;
}

.resource-nav-link {
  padding: 24px 0;
  font-size: 16px;

  a {
    color: #333;
  }

  i {
    margin: 0 6px;
  }

  strong {
    color: #999;
  }
}

.resource-content {
  padding-bottom: 40px;
}

.resource-content-c {
  // display: inline-block;
  // width: 70%;
  background-color: #fff;
  padding: 20px 30px;

  .resource-box-top {
    margin-bottom: 40px;
  }

  .resource-icon {
    max-width: 42px;
    max-height: 52px;
    overflow: hidden;
    float: left;
  }

  .resource-con-info {
    margin-left: 75px;
  }

  .resource-box-l {
    .resource-title {
      font-size: 18px;
      line-height: 20px;
      max-width: 500px;
    }

    .create-info {
      font-size: 12px;
      line-height: 16px;
      color: #888888;
      margin-top: 15px;
    }

    .creater-name {
      color: #020202;
      margin-right: 10px;
    }

    em {
      padding-right: 15px;
      padding: 0 10px;
      border-right: 1px solid #888;

      &:last-of-type {
        border: 0 none;
      }
    }

    .score {
      color: #888888;
      // margin-left: 15px;
    }
  }

  .download-btn {
    margin-top: 10px;
    padding: 0;
    width: 80px;
    height: 36px;
    border: 0 none;
    background: #E62126;
  }

  .resource-content-mid {
    display: inline-block;
    margin-left: 39px;

    li {
      display: inline-block;

      .icon_see {
        margin-right: 14px;
        width: 20px;
        height: 14px;
        background: url("../../../assets/images/shoucang@2x.png");
        background-size: contain;
      }

      .download01 {
        margin-right: 14px;
        width: 16px;
        height: 18px;
        background: url("../../../assets/images/download@2x.png");
        background-size: contain;
      }

      &:nth-child(2) {
        padding-left: 16px;
        border-left: 1px solid #979797;
      }
    }

    em {
      padding: 0 15px 0 0;
      color: #7693bd;
      line-height: 16px;
      border: 0 none;
    }
  }

  .resource-content-bottom {
    margin-top: 20px;
    height: 500px;
    line-height: 500px;

    #playercontent {
      height: 100%;
    }
    .imgBox {
      width: 100%;
      height: 100%;
      overflow: auto;
      text-align: center;
    }

    .empty-bgc-img {
      display: inline-block;
      width: 100%;
      height: 500px;
      background-image: url("../../../assets/images/moren@2x.png");
      background-size: 100% 100%;
      position: relative;

      .resource-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        text-align: center;
        visibility: hidden;
        opacity: 0;
        -moz-transition: all 0.35s ease-in;
        -webkit-transition: all 0.35s ease-in;
        -o-transition: all 0.35s ease-in;
        transition: all 0.35s ease-in;
      }

      &:hover .resource-mask {
        visibility: visible;
        opacity: 1;
      }

      span {
        font-size: 24px;
        color: #ffffff;
        background: rgba(0, 0, 0, 0.1);
        // border-radius: 15px;
        height: 50px;
        line-height: 50px;
        display: block;
        width: 370px;
        text-align: center;
        position: absolute;
        top: 45%;
        left: 50%;
        margin-left: -170px;
      }
    }

    .common-box {
      text-align: center;
      background-color: #ccc;
    }

    .transform-loading {
      display: flex;
      justify-content: center;
      font-size: 20px;
      color: #fff;
      background-color: #a9cbe3;
    }
  }

  .resource-content-tool {
    margin: 20px 0 0;

    .mark {
      span,
      .el-rate {
        vertical-align: middle;
        font-size: 14px;
      }

      .el-rate {
        display: inline;
        margin-left: 10px;
      }
    }

    .collect-share {
      .a-tit {
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        margin-right: 10px;
      }
    }

    .resource-collect {
      height: 28px;
      line-height: 28px;
      padding-right: 15px;
      font-size: 14px;

      .ipng {
        height: 16px;
        cursor: pointer;
        margin-left: 5px;
      }

      .collect {
        background-position: -465px -774px;
      }

      .uncollect {
        background-position: -440px -774px;
      }

      .line {
        border-right: 1px solid #b1bdc2;
        padding-left: 20px;
      }
    }
  }
}

.resource-content-r {
  display: inline-block;
  width: 22%;
  background-color: #fff;
  padding: 5px 10px;
  box-sizing: border-box;

  .resource-info-title {
    padding-bottom: 15px;

    .words {
      font-size: 14px;
      color: #666;
      line-height: 40px;
    }

    .words,
    .el-button {
      vertical-align: middle;
    }
  }

  .resource-info-li {
    margin-bottom: 30px;
    cursor: pointer;

    .file-img {
      display: block;
      max-width: 42px;
      max-height: 52px;
      overflow: hidden;

      img {
        display: inline-block;
        width: 100px;
        vertical-align: top;
      }
    }

    .file-text {
      margin-left: 50px;
      font-size: 12px;
      line-height: 16px;
    }

    .file-name {
      height: 30px;
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;
    }

    .file-info {
      margin-top: 10px;
    }

    .download-count {
      margin-right: 10px;
      color: #666;
    }

    .section-info {
      color: #666;
    }
  }
}
</style>
